import { NeuroNoise } from "@paper-design/shaders-react";

interface HeroShaderProps {
  originX?: number;
  originY?: number;
  offsetX?: number;
  offsetY?: number;
  scale?: number;
  rotation?: number;
  speed?: number;
  contrast?: number;
  brightness?: number;
}

/**
 * Neuro-noise shader used as the hero container background.
 * All the visual params are driven from the parent so the blue pattern
 * itself can warp / stretch / rotate as the cursor moves.
 */
export default function HeroShader({
  originX = 0.5,
  originY = 0.5,
  offsetX = 0,
  offsetY = 0,
  scale = 1,
  rotation = 0,
  speed = 1,
  contrast = 0.3,
  brightness = 0.05,
}: HeroShaderProps) {
  return (
    <div className="absolute inset-0">
      <NeuroNoise
        fit="none"
        scale={scale}
        rotation={rotation}
        offsetX={offsetX}
        offsetY={offsetY}
        speed={speed}
        originX={originX}
        originY={originY}
        worldWidth={0}
        worldHeight={0}
        colorFront="#ffffff"
        colorMid="#6BB5FA"
        colorBack="#000000"
        brightness={brightness}
        contrast={contrast}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}